<template>
   <v-container fluid id="PrintFB">
    <v-card
      color="oug"
      class="pa-1 mx-auto text-center justify-center"
      elevation="24"
    >
      <v-card class="pa-10">
        <v-form ref="TeamSel" v-if="Step==1" lazy-validation>
          <h2>Select a Team</h2>
          <p></p>
          <v-select
            outlined
            v-model="SelectedTeam"
            :items="Teams"
            item-text="Detail"
            filled 
            return-object
            label="Select Team"
            prepend-inner-icon="mdi-microsoft-teams"
            dense
            :rules="[rules.required('Team selection is Required')]"
          ></v-select>
          <v-btn
            class="mt-2 mr-2"
            color="blue"
            dark
            depressed
            elevation="24"
            @click="Teamvalidate"
          >
            <v-icon left>mdi-skip-next</v-icon>
            Next
          </v-btn>
        </v-form>
        <v-form ref="PersonSel" v-if="Step==2" lazy-validation>
          <h2>Select a Person</h2>
          <p></p>
          <v-select
            outlined
            v-model="SelectedPerson"
            :items="People"
            item-text="Name"
            filled 
            return-object
            label="Select Person to Recieve Feedback"
            prepend-inner-icon="mdi-account-check-outline"
            dense
            :rules="[rules.required('Person selection is Required')]"
          ></v-select>
          <v-row class="pa-1">
            <v-btn
              class="mt-2 mr-2"
              color="blue"
              dark
              depressed
              elevation="24"
              @click="Step = 1"
            >
              <v-icon left>mdi-skip-previous</v-icon>
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="mt-2 mr-2"
              color="blue"
              dark
              depressed
              elevation="24"
              @click="Personvalidate"
            >
              <v-icon left>mdi-skip-next</v-icon>
              Next
            </v-btn>
          </v-row>
        </v-form>
        <v-form ref="Feedback" v-if="Step==3" lazy-validation>
          <h2>Enter {{SelectedPerson.Name}}'s Feedback</h2>
          <p></p>
          <v-select
            outlined
            multiple
            v-model="SelectedCoachability"
            :items="CoachabilityItems"
            label="Coachability Feedback"
            dense
            :rules="[rules.required('Coachability selection is Required')]"
          ></v-select>
          <v-select
            outlined
            multiple
            v-model="SelectedOffSkills"
            :items="SkillSetOffItems"
            label="Offensive Skills Feedback"
            dense
            :rules="[rules.required('Offensive Skills selection is Required')]"
          ></v-select>
          <v-select
            outlined
            multiple
            v-model="SelectedDefSkills"
            :items="SkillSetDefItems"
            label="Defensive Skills Feedback"
            dense
            :rules="[rules.required('Defensive Skills selection is Required')]"
          ></v-select>
          <v-select
            outlined
            multiple
            v-model="SelectedPhysical"
            :items="PhysicalDevItems"
            label="Physical Development and Conditioning Feedback"
            dense
            :rules="[rules.required('Physical Development and Conditioning selection is Required')]"
          ></v-select>
          <v-select
            outlined
            multiple
            v-model="SelectedAthletic"
            :items="AthleticismItems"
            label="Athleticism Feedback"
            dense
            :rules="[rules.required('Athleticism selection is Required')]"
          ></v-select>
          <v-select
            outlined
            multiple
            v-model="SelectedGameSense"
            :items="GameSenseItems"
            label="Game Sense Feedback"
            dense
            :rules="[rules.required('Game Sense selection is Required')]"
          ></v-select>
          <v-select
            outlined
            multiple
            v-model="SelectedCompliance"
            :items="ApplicationComplianceItems"
            label="Application and Compliance Feedback"
            dense
            :rules="[rules.required('Application and Compliance selection is Required')]"
          ></v-select>
          <v-textarea
            v-model="Comments"
            auto-grow
            outlined
            dense
            rows="2"
          ></v-textarea>
          <v-row class="pa-1">
            <v-btn
              class="mt-2 mr-2"
              color="blue"
              dark
              depressed
              elevation="24"
              @click="Step = 2"
            >
              <v-icon left>mdi-skip-previous</v-icon>
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="mt-2 mr-2"
              color="blue"
              dark
              depressed
              elevation="24"
              @click="Feedbackvalidate"
            >
              <v-icon left>mdi-skip-next</v-icon>
              Next
            </v-btn>
          </v-row>
        </v-form>
        <v-form ref="Review" v-if="Step==4" lazy-validation>
              <h2>{{SelectedPerson.Name}} Feedback as given by {{Coach}}</h2>
              <p></p>
              <h5 class="text-left justify-left">Coachability Feedback:</h5>
              <div class="Feedback" v-html="strCoachability"></div>

              <h5 class="text-left justify-left">Offensive Skillset Feedback:</h5>
              <div class="Feedback" v-html="strOffSkills"></div>

              <h5 class="text-left justify-left">Defensive Skillset Feedback:</h5>
              <div class="Feedback" v-html="strDefSkills"></div>

              <h5 class="text-left justify-left">Physical Development and Conditioning Feedback:</h5>
              <div class="Feedback" v-html="strPhysical"></div>

              <h5 class="text-left justify-left">Athleticism Feedback:</h5>
              <div class="Feedback" v-html="strAthletic"></div>

              <h5 class="text-left justify-left">Game Sense Feedback:</h5>
              <div class="Feedback" v-html="strGameSense"></div>

              <h5 class="text-left justify-left">Application and Compliance Feedback:</h5>
              <div class="Feedback" v-html="strCompliance"></div>
              <p></p>
              <h5 class="text-left justify-left">General Comments:</h5>
              <div class="Feedback" v-text="Comments"></div>
              <p></p>
          <v-row class="pa-1">
            <v-btn
              id="Previous"
              class="mt-2 mr-2"
              color="blue"
              dark
              depressed
              elevation="24"
              @click="Step = 3"
            >
              <v-icon left>mdi-skip-previous</v-icon>
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              id="Process"
              class="mt-2 mr-2"
              color="blue"
              dark
              depressed
              elevation="24"
              @click="Reviewvalidate"
            >
              <v-icon left>mdi-skip-next</v-icon>
              Process
            </v-btn>
          </v-row>
        </v-form>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>

import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import axios from "axios";


    export default {
       data() {
    return {
      Comments: null,
      Coach: null,
      Step: 1,
      SelectedTeam: null,
      Teams: [],
      SelectedPerson: null,
      People: [],
      rules: {
        required: msg => v => !!v || msg
        //required: (value) => !!value || "Required.",
      },
      Feedback: null,
      SelectedCoachability: null,
      strCoachability: null,
      CoachabilityItems: [
          "Good leadership abilities when using voice. Has the ability to organise others and show direction at training sessions. ",
          "Great listener and has the ability to implement instruction and feedback given from the coaches",
          "Can lose those focus throughout sessions. Needs to work on consistency of focus, effort levels and intensity at training",
          "Poor listener and poor attitude. Does not take coach instruction and feedback well. This must be addressed immediately."
      ],
      SelectedOffSkills: null,
      strOffSkills: null,
      SkillSetOffItems: [
          "Inside presence and understanding of high/low concepts and getting into post positions.",
          "Good at using length and size to seal but needs to develop a finishing package vs longer defenders. Will need to progress to secondary moves, fakes and footwork in order to maximise this to at national level.",
          "Continue to work on weak side of body and finishing vs contact/length.",
          "Continue to work on shooting from the perimeter. Shooting is the master skill and working towards becoming elite at this will enhance development.",
          "Continue to work on ball handling particularly weak hand. Must start to become a ball handler/playmaker off the dribble. Ball handling improvement will help with guard skills and attacking the defence off the dribble.",
          "Continue to work on pick and roll play and understanding the decision making around this. The two keys of the pick and roll to continue to work on are 'when to score' and 'when to pass' in different situations.",
          "Continue to work on passing with both hands particularly when under pressure on penetration.",
          "Good ability to shoo the 3pt shot. Continue to make this your elite skill and focus",
          "Potential to be an elite shooter from 3. Continue to work on this skill."
      ],
      SelectedDefSkills: null,
      strDefSkills: null,
      SkillSetDefItems: [
          "Playing with verticality around the rim and avoiding fouling. Use length and size to change shots rather than block shots.",
          "Containment of quicker, more agile post players/wings and keeping them in front. Need to better understand angles and playing through the chest on drives without fouling.",
          "Work on containment of the ball, understanding the check points on the floor.",
          "Continue to work on chest blows and wall ups. Being physical when you defend",
          "Continue to work on understanding of Pick and Roll coverages",
          "Continue to work on understanding of Tagging Up concepts in DTRANS"
      ],
      SelectedPhysical: null,
      strPhysical: null,
      PhysicalDevItems: [
          "Good Size and Length",
          "Elite Conditioning and Fitness",
          "Need to improve overall conditioning and movement in pace phase"
      ],
      SelectedAthletic: null,
      strAthletic: null,
      AthleticismItems: [
          "Needs to improve explosiveness to help in PACE phase and off the dribble offensively",
          "Needs to improve foot speed to help with on ball defence",
          "Good footspeed and lateral quickness",
          "Elite footspeed and lateral quickness",
          "Good vertical and straight line athleticism",
          "Elite vertical and straight line athleticism"
      ],
      SelectedGameSense: null,
      strGameSense: null,
      GameSenseItems: [
          "Good feel for concepts within the framework of capabilities.",
          "Need to have a better understanding of floor spots offensively. This will ensure you are able to play in multiple positions.",
          "Continue to work on BQ Style of Play",
          "Continue to work on decision making on penetration",
          "Continue to work and have an understanding on shot selection regarding the team’s offence, time and score.",
          "Continue to work on understanding of Pick and Roll Concepts"
      ],
      SelectedCompliance: null,
      strCompliance: null,
      ApplicationComplianceItems: [
          "Always on time, always committed to the session.",
          "Effort always at 100% throughout sessions",
          "Extremely coachable throughout all sessions",
          "Needs to be more punctual and on time",
          "Needs to be more attentive to OUG wellness and load management."
      ],
      Review: null,
      pdf: null,
      filename: 'My Submission',
      quality: 1, // Higher the better but larger file

    };
  },
  created() {
      this.Teams = JSON.parse(localStorage.getItem("Coach")).current_access
      this.Coach = `${JSON.parse(localStorage.getItem("Coach")).contact.Firstname} ${JSON.parse(localStorage.getItem("Coach")).contact.Surname}` 
  },
  methods: {
    Teamvalidate() {
        if (this.$refs.TeamSel.validate()) {
          this.getPeople()
        }
    },
    Personvalidate() {
        if (this.$refs.PersonSel.validate()) {
          this.Step = 3
        }
    },
    Feedbackvalidate() {
        if (this.$refs.Feedback.validate()) {
          this.Step = 4
          // Process Next Step
          this.strCoachability = this.replaceCommaBreak(this.SelectedCoachability)
          this.strOffSkills = this.replaceCommaBreak(this.SelectedOffSkills)
          this.strDefSkills = this.replaceCommaBreak(this.SelectedDefSkills)
          this.strPhysical = this.replaceCommaBreak(this.SelectedPhysical)
          this.strAthletic = this.replaceCommaBreak(this.SelectedAthletic)
          this.strGameSense = this.replaceCommaBreak(this.SelectedGameSense)
          this.strCompliance = this.replaceCommaBreak(this.SelectedCompliance)

        }
    },
    async Reviewvalidate() {
          document.getElementById("Previous").style.visibility = "hidden";
          document.getElementById("Process").style.visibility = "hidden";
          let ele = document.getElementById("PrintFB")
          const toastId = this.$toast(`Creating Feedback to add to Person's profile - Please Wait!`, {
                    timeout: false, closeButton: false,
                });
          this.savePage2PDF(ele, toastId)
    },
    clearData() {
      this.Comments = null
      this.SelectedTeam = null
      this.SelectedPerson = null
      this.Feedback = null
      this.SelectedCoachability =  null
      this.strCoachability = null
      this.SelectedOffSkills = null
      this.strOffSkills = null
      this.SelectedDefSkills = null
      this.strDefSkills = null
      this.SelectedPhysical = null
      this.strPhysical = null
      this.SelectedAthletic = null
      this.strAthletic = null
      this.SelectedGameSense = null
      this.strGameSense = null
      this.SelectedCompliance = null
      this.strCompliance = null
      this.Review = null
      this.pdf = null
    },
    savePage2PDF(page, toastId) {
        this.pdf = new jsPDF('p', 'mm', 'a4', true);
        html2canvas(page,
            { scale: this.quality }
        ).then(canvas => {
            this.pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 211, 298);
            let blob = this.pdf.output('blob');
            let fdataobj = new FormData();
              fdataobj.append("UploadFile", blob);
              const baseURL = "https://server.ownurgoal.net.au/file/uploadSingleFile";
              axios.post(baseURL, fdataobj, { 'Content-Type': 'multipart/form-data' })
              .then((response) => {
                  // Get File name here
                  let path = response.data.filename
                  let startpos = path.lastIndexOf("/")
                  this.savetoOUGDocuments(this.SelectedPerson.Contact_id, path.substr((startpos+1),60), toastId)
              })
              .catch((error) => {
                  console.log(error);
              });
        });
    },
    savetoOUGDocuments(Contactid, filename, toastId) {
      return new Promise((resolve, reject) => {
        let  jsonDetails = {
                  "Contact_Details_id": 0,
                  "Contact_id": Contactid,
                  "Type": 3522,
                  "Description": 'Feedback Provided',
                  "Details": filename 
              }
        let oParsedObject = {
              "Payload": jsonDetails,
              "Table": "Contact_Details",
              "Primary_Key": "Contact_Details_id",
              "Action": "INSERT"
          };
        // Call Axios function to do the conversion
        const baseURL = "https://server.ownurgoal.net.au/gen/EditTable";
        // Add Feedback to OUG Documents
        axios
            .post(baseURL, oParsedObject)
            .then((response) => {
                this.$toast.dismiss(toastId);
                this.$toast.success(`Document has been saved to the person's profile on OwnUrGoal!`, {
                    timeout: 1000,
                });
                document.getElementById("Previous").style.visibility = "visible";
                document.getElementById("Process").style.visibility = "visible";
                // Clear the form values and reset
                this.clearData();
                this.Step = 2
                resolve(response.data)

            })
            .catch((error) => {
              this.$toast.dismiss(toastId);
              this.$toast.error(`A pdf copy to your responses could not be generated - Please ensure you have the latest version of the OUG App!`, {
                  timeout: 1000,
              });
              reject(error);
            });
      });
    },
    replaceCommaLine(data) {
        //convert array to string replacing comma with new line
        return data.join("\n");
    },
    replaceCommaBreak(data) {
        let ArrData = []
        data.forEach(element => {
            ArrData.push(`<li>${element}</li>`) ;
        });
        let str = ArrData.join('');
        return `<ul>${str}</ul>`;
    },
    getPeople() {
      let payload = { Code_id: this.SelectedTeam.Code_id }
      // Call Axios function to do the conversion
      const baseURL = "https://server.ownurgoal.net.au/gen/GetTeamMembers";
      axios
        .post(baseURL, payload)
        .then((response) => {
          this.People = response.data.result
          this.People.forEach(element => {
             element.Name = `${element.Firstname} ${element.Surname}`
          });
          this.Step = 2
        })
        .catch((error) => {
          this.$toast.error(`Could not be load people - Please Try Again!`, {
              timeout: 1000,
          });
          console.log(error)
        });
    },
  },
}; 
</script>

<style lang="scss" scoped>

.v-select-list {
    text-align: left;
}

.textarea {
   resize: none;
}

.Feedback {
  border: 1px solid black;
  padding: 5px;
  margin: 5px;
  text-align: left;
  white-space: pre-wrap;
}

.h5 {
  text-align: left;
}




</style>